import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { PassengerManualNotif } from '../../../models/passenger-manual-notif';

@Component({
  selector: 'app-passenger-manual-notif-show',
  templateUrl: './passenger-manual-notif-show.component.html',
  styleUrls: ['./passenger-manual-notif-show.component.css']
})
export class PassengerManualNotifShowComponent implements OnInit {
  public passengerManualNotif: PassengerManualNotif;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
  ) {

    this.route.params.subscribe(params => {
      this.http.get(
        '/api/passengerManualNotif/' + params['id']
      ).subscribe((passengerManualNotif: PassengerManualNotif) => {
        this.passengerManualNotif = passengerManualNotif;
      });
    });

  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/passenger-manual-notif/passenger-manual-notif-show/passenger-manual-notif-show.component.ts